import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-lightbulb_svg__a"
        d="M12 6c-3.3 0-6 2.7-6 6 0 2 1 3.8 2.5 4.8l.2.6c.2.9 1 1.5 1.9 1.5h2.9c.9 0 1.7-.6 1.9-1.5l.2-.6C17 15.8 18 14 18 12c0-3.3-2.7-6-6-6zm2.4 9.2c-.4.3-.6.7-.8 1.1l-.2.7h-2.8l-.2-.6c-.1-.5-.4-.9-.8-1.1-1-.8-1.6-2-1.6-3.3 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.3-.6 2.5-1.6 3.2zM12 22c1.4 0 2.7-.8 3-2H9c.3 1.1 1.6 2 3 2zM11 2h2v2h-2V2zm6.662 1.697l1.532 1.285-1.286 1.532-1.532-1.285 1.286-1.532zm4.012 5.582l.348 1.97-1.97.347-.347-1.97 1.97-.347zm-.514 6.855l-1 1.732-1.732-1 1-1.732 1.732 1zM3.84 17.866l-1-1.732 1.732-1 1 1.732-1.732 1zm-1.862-6.618l.348-1.97 1.97.348-.348 1.97-1.97-.348zm2.828-6.266l1.532-1.285 1.286 1.532-1.532 1.285-1.286-1.532z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-lightbulb_svg__a"
    />
  </svg>
);
